import { Box } from '@domain-group/suit-theme'

import useInvoiceItems from '@hooks/useInvoiceItems'

import type { InvoiceItemModel, InvoiceModel } from '@models/types'

import InvoiceItemListItem from './InvoiceItemListItem'

const InvoiceItems = (props: {invoice: InvoiceModel}) => {
  const { invoice } = props

  const { filteredInvoiceItems, hasFilteredInvoiceItems } = useInvoiceItems({ filters: { invoice_id: invoice.id } })

  return (
    <Box marginBottom={hasFilteredInvoiceItems ? 'large' : ''} flexDirection="column">
      {filteredInvoiceItems.map((invoiceItem: InvoiceItemModel) => <InvoiceItemListItem invoiceItem={invoiceItem} />)}
    </Box>
  )
}

export default InvoiceItems
